import React from 'react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import ActionButton from '../../components/ActionButton.jsx'; 

const PaymentSuccessPage = ({ isTemporary }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Backend should redirect to /payment/success?analysisId=123?amount=25
  const analysisId = searchParams.get('analysisId');
  const amount = searchParams.get('amount');  

  // number of step for redirection, registered user with credit check config again, not registered users go to categories
  const stepNum = isTemporary ? 4 : 3;

  useEffect(() => {
    window.dataLayer.push({
      event: 'payment_success',
      value: amount,
      currency: 'CZK'
    });
  }, [amount]); 

  return (
    <div className="flex justify-center min-h-full p-4 pt-8 pb-16 bg-gray-50">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-xl p-8 md:p-12">
        <div className="flex flex-col items-center text-center">
          <CheckCircle className="w-20 h-20 text-green-500 mb-6" />
          <h2 className="text-3xl font-bold text-gray-800">Platba proběhla úspěšně!</h2>
          <p className="text-gray-600 mt-4 text-lg">
            Převedení prostředků může chvilku trvat.
          </p>
          {analysisId ? ( // Return to the wizard at step 5
            <ActionButton 
              onClick={() => navigate(`/analysis/create?step=${stepNum}&fileId=${analysisId}`)}
              className="mt-10 w-full"
            >
              Zpět k analýze
            </ActionButton>
          ) : ( // Just bought credits, go to dashboard
            <ActionButton 
              onClick={() => navigate('/dashboard')}
              className="mt-10 w-full"
            >
              Zpět na Dashboard
            </ActionButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;